import * as ActionTypes from './actionTypes'

export const setBeginDisplayFeedbackOverlay = (feedbackPanes, panesStateLocation, activeStateLocation) => {
    return {
        type : ActionTypes.BEGIN_DISPLAY_FEEDBACK_OVERLAY,
	    payload : {
            feedbackPanes,
            panesStateLocation,
            activeStateLocation
        }
    }
};

export const setActiveFeedbackPane = (paneId, stateLocation) => {
    return {
        type : ActionTypes.SET_ACTIVE_FEEDBACK_PANE,
        payload : {
            paneId,
            stateLocation
        }
    }
};

export const updateOverlayFormFocusState = (shouldFocus, stateLocation) => {
    return {
        type : ActionTypes.SET_ACTIVE_FEEDBACK_PANE_FOCUS,
        payload : {
            shouldFocus,
            stateLocation
        }
    }
};

export const endDisplayFeedbackPanes = (panesStateLocation, activeStateLocation) => {
    return {
        type : ActionTypes.END_DISPLAY_FEEDBACK_PANES,
        payload : {
            panesStateLocation,
            activeStateLocation
        }
    }
};

export const setCapturedFeedback = (feedbackInfo, stateLocation) => {
    return {
        type : ActionTypes.SET_CAPTURED_FEEDBACK,
        payload : {
            feedbackInfo,
            stateLocation
        }
    }
};

export const sendCapturedFeedback = (stageLocation, capturedLocation) => {
    return {
        type : ActionTypes.SEND_CAPTURED_FEEDBACK,
        payload: {
            stageLocation,
            capturedLocation
        }
    }
};

export const clearCapturedFeedback = (stateLocation) => {
    return {
        type : ActionTypes.CLEAR_CAPTURED_FEEDBACK,
        payload : {
            stateLocation
        }
    }
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-feedback-overlay/src/actions/actions.js